import type { FillOpenTransactionsDataParameters } from '@app/shared/types/sf-data'

import SFetch from '@app/utils/sfetch'
import { SfLog } from '@app/adapters/logger'

export function fillOpenTransactionsData(
  parameters: FillOpenTransactionsDataParameters
): void {
  try {
    SFetch.postFormRedirect({
      url: parameters.actionPath,
      method: 'post',
      authenticityToken: window.Silverfin.csrfToken(),
      data: [],
    })
  } catch (error) {
    SfLog.error('Request failed', {
      extra: {
        error: error,
      },
    })
  }
}
